import i18n from '@/localisation/i18n';

export const DashboardBanner = ({
  title,
  subtitle,
  img,
}: {
  title: string;
  subtitle: string;
  img: string;
}) => {
  return (
    <div className="block w-full rounded-lg border border-primary bg-[#6854FF33] p-6 md:h-64 md:min-w-[536px]">
      <div className="flex h-full w-full flex-col items-center justify-between md:flex-row">
        <div className="mr-5 flex h-full flex-col">
          <div className="w-full md:min-w-60">
            <h3 className="text-base font-bold md:text-lg">{title}</h3>
            <h5 className="mt-3 line-clamp-4 text-base md:mt-5 md:text-lg">
              {subtitle}
            </h5>
          </div>
          <div className="mt-5 flex md:mt-auto">
            <div className="mr-2 text-xs font-semibold">
              {i18n.t('banner.addClient.link')}
            </div>
            <img
              width={14}
              height={14}
              className="rotate-180"
              src="/icons/back_arrow.svg"
              alt="arrow"
            />
          </div>
        </div>
        <img
          className="mt-5 w-full md:h-full md:w-auto"
          src={img}
          alt="new user"
        />
      </div>
    </div>
  );
};
